/* eslint-disable import/no-unresolved */
import React from 'react';
import { useTranslation } from 'react-i18next';

import ButtonComponent from '../../../../components/ButtonMC';
import TextBlock from './TextBlock';
import PaymentMethodsList from './PaymentMethodsList';

const SendPdfWithPaymentLinksContent = ({
  onSend,
  mainContainerClassName = '',
  containerClassName = '',
  header,
  actionButton = false,
  paymentMethods = [],
  onToggle,
  saving = false
}) => {
  const { t } = useTranslation('Inbox');

  return (
    <div className="tw-wrapper ">
      <div className={`tw-flex tw-flex-col tw-gap-6 ${mainContainerClassName}`}>
        <div className={`tw-flex tw-flex-col tw-gap-6 tw-overflow-y-auto tw-break-words ${containerClassName}`}>
          {header}

          <div className="tw-flex tw-flex-col tw-gap-6">
            <div className="tw-flex tw-flex-col tw-gap-2">
              <TextBlock
                title={t('sendPaymentLinks.payment_link')}
                description={t('sendPaymentLinks.sendPdfDescription')}
              />
              <div className="tw-flex tw-flex-col tw-gap-2.5">
                <PaymentMethodsList
                  methods={paymentMethods}
                  onToggle={onToggle}
                />
              </div>
            </div>
          </div>
        </div>

        {actionButton && (
          <div className="tw-flex tw-px-2">
            <ButtonComponent
              onClick={onSend}
              text={t('sendPaymentLinks.sendPdf')}
              className="tw-w-full"
              size="medium"
              variant={saving ? 'GRAY' : 'PRIMARY'}
              disabled={saving}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SendPdfWithPaymentLinksContent;

